export default __webpack_public_path__ + "static/media/calendar_normal.409e3739.svg";